export enum RecurrenceTypes {
  yearly = 'Yearly',
  monthly = 'Monthly',
  daily = 'Daily',
  hourly = 'Hourly',
}
